/* MIcase - POP-UPS Y VUELO AL CARRITO. Comportamiento extraido de
   sections/micase-popups.liquid el 2026-08-18.

   POR QUE SE SACO. La seccion pesaba 92.196 bytes y la API de temas solo escribe archivos
   COMPLETOS: para cambiar una linea habia que reenviar los 92 KB en una sola llamada. Eso es
   lo que dejo micase-combo.js truncado el 17 de agosto, sin dar ningun error y con el combo
   muerto en todo el borrador. Y este archivo gobierna el anadido por AJAX: si llega cortado,
   se rompe comprar. Partido, cada pieza se edita y se verifica por separado. Mismo patron
   que micase-header.liquid.

   QUE SE QUEDO EN LA SECCION: el marcado, el CSS -que sale de dos capture de Liquid- y las
   dos islas JSON, #mcpg-stock y #mcpg-cfg, que traen los ajustes del editor. Este archivo no
   tiene una sola linea de Liquid a proposito.

   EL LITERAL DE RESPALDO. El objeto C llevaba seis valores de Liquid. Ahora van con el valor
   de fabrica escrito a mano y no cambia nada: la linea siguiente pisa C entero con lo que
   venga en #mcpg-cfg, que es donde estan los ajustes de verdad. */
    (function(){
      var N = document.getElementById('mcpg-cfg');
      var C = {
        vuelo: true,
        nocajon: true,
        ventana: 4,
        ajax: true,
        pagar: false,
        t: { espera: 'Agregando…', error: 'No pudimos agregarlo. Inténtalo otra vez.' }
      };
      if (N) { try { C = JSON.parse(N.textContent) } catch(e) { console.warn('[MIcase] micase-popups: no se pudo leer el JSON de configuracion del popup', e); } }
      var T = C.t || {};

      var suave = true;
      try { suave = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) } catch(e) { console.warn('[MIcase] micase-popups: no se pudo consultar prefers-reduced-motion', e); }

      /* 2026-08-18: .mcbc__btn es el boton de la barra pegajosa de compra, que no lleva
         name="add" y por eso nunca disparaba el vuelo. Es la que mas vende. */
      var SEL_ADD = 'button[name="add"], .mcbc__btn, .mccombo__f button, .mcx__f button, #mccombo-cta';
      /* 2026-08-18: el chip del carrito de la barra de compra va PRIMERO. En la ficha en
         movil la cabecera no es pegajosa, asi que #cart-icon-bubble esta a miles de
         pixeles por encima y el vuelo terminaba fuera de la pantalla. */
      var SEL_CARRO = ['.mcbc__carro', '#cart-icon-bubble', '.header__minicart .cart-count', '.minicart__action', '.cart-count'];

      function visible(n){
        if(!n) return false;
        var r = n.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      }

      /* 2026-08-18 - DOS PASADAS. visible() solo comprueba que el elemento MIDA algo, no
         que se vea: por eso el vuelo se iba a un icono fuera de la ventana. Primero se busca
         un destino que este de verdad en pantalla; solo si no hay ninguno se acepta el que
         exista, y entonces vuelaAhora recorta el final al borde. */
      function enPantalla(n){
        if(!visible(n)) return false;
        var r = n.getBoundingClientRect();
        return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight || 0);
      }
      function destino(){
        var i, j, ns;
        for(i=0;i<SEL_CARRO.length;i++){
          ns = document.querySelectorAll(SEL_CARRO[i]);
          for(j=0;j<ns.length;j++){ if(enPantalla(ns[j])) return ns[j] }
        }
        for(i=0;i<SEL_CARRO.length;i++){
          ns = document.querySelectorAll(SEL_CARRO[i]);
          for(j=0;j<ns.length;j++){ if(visible(ns[j])) return ns[j] }
        }
        return null;
      }

      function pulso(){
        var cc = document.querySelectorAll('[data-mc-contador], .cart-count');
        for(var i=0;i<cc.length;i++){
          (function(n){
            if(!visible(n)) return;
            n.classList.remove('mcpg-lat');
            void n.offsetWidth;
            n.classList.add('mcpg-lat');
            setTimeout(function(){ n.classList.remove('mcpg-lat') }, 700);
          })(cc[i]);
        }
      }

      function imagenOrigen(btn){
        var n = btn, i = 0;
        while(n && n !== document.body && i < 7){
          var im = n.querySelector ? n.querySelector('img') : null;
          if(im && visible(im)) return im;
          n = n.parentNode; i++;
        }
        var alt = ['.main-product .swiper-slide-active img', '.main-product .product-media img', '.product-media img', '.main-product img'];
        for(var k=0;k<alt.length;k++){
          var c = document.querySelectorAll(alt[k]);
          for(var j=0;j<c.length;j++){
            if(visible(c[j]) && c[j].getBoundingClientRect().width > 60) return c[j];
          }
        }
        return null;
      }

      /* 2026-08-18 - EL DESTINO SE LEE 320 ms DESPUES, NO EN EL CLIC.
         La barra de compra sube sola al anadir, pero tarda 220 ms en entrar por su
         transicion. Leyendo el destino en el clic, el chip todavia estaria fuera de la
         pantalla y volveriamos al fallo de siempre. El ORIGEN si se lee ya, porque la
         galeria puede repintarse. 320 ms no se perciben antes de una animacion de 700. */
      function vuela(btn){
        if(!C.vuelo) return;
        if(!suave){ pulso(); return; }
        var img = imagenOrigen(btn);
        if(!img) return;
        var src = img.currentSrc || img.src;
        if(!src) return;
        var r = img.getBoundingClientRect();
        if(!r.width || !r.height) return;
        setTimeout(function(){ vuelaAhora(src, r) }, 320);
      }

      function vuelaAhora(src, r){
        var dest = destino();
        if(!dest) return;
        var d = dest.getBoundingClientRect();

        var cl = document.createElement('img');
        cl.src = src;
        cl.alt = '';
        cl.setAttribute('aria-hidden', 'true');
        cl.className = 'mcpg-fly';
        cl.style.left = r.left + 'px';
        cl.style.top = r.top + 'px';
        cl.style.width = r.width + 'px';
        cl.style.height = r.height + 'px';
        document.body.appendChild(cl);

        var dx = (d.left + d.width / 2) - (r.left + r.width / 2);
        var dy = (d.top + d.height / 2) - (r.top + r.height / 2);
        /* Si aun asi el destino quedo fuera de la ventana -por ejemplo en el carrito, donde
           no hay chip-, el vuelo termina en el borde mas cercano en vez de salirse: se ve
           entero y sigue senalando hacia donde esta el carrito. */
        var alto = window.innerHeight || document.documentElement.clientHeight || 0;
        var cy = r.top + r.height / 2;
        if (d.bottom < 0) dy = -cy + 24;
        else if (alto && d.top > alto) dy = (alto - cy) - 24;
        var esc = Math.max(0.16, Math.min(30 / r.width, 0.9));
        var listo = false;
        function fin(){
          if(listo) return;
          listo = true;
          if(cl.parentNode) cl.parentNode.removeChild(cl);
          pulso();
        }

        if(typeof cl.animate === 'function'){
          var a = cl.animate([
            { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
            { transform: 'translate3d(' + (dx * 0.55) + 'px,' + (dy * 0.55 - 40) + 'px,0) scale(' + ((1 + esc) / 2) + ')', opacity: 0.9, offset: 0.6 },
            { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + esc + ')', opacity: 0.1 }
          ], { duration: 700, easing: 'cubic-bezier(.5,.05,.25,1)', fill: 'forwards' });
          a.onfinish = fin;
          a.oncancel = fin;
        } else {
          cl.style.transition = 'transform .7s cubic-bezier(.5,.05,.25,1), opacity .7s ease-in';
          requestAnimationFrame(function(){
            cl.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + esc + ')';
            cl.style.opacity = '0.1';
          });
          cl.addEventListener('transitionend', fin);
        }
        setTimeout(fin, 1400);
      }

      var marcaAdd = 0, cajonSucio = false;
      // Ventana en la que un anadido reciente impide que el cajon se abra solo.
      var ventanaAdd = (typeof C.ventana === 'number' && C.ventana > 0) ? C.ventana * 1000 : 4000;

      // 2026-08-10 · EL CAJON NO SE REFRESCABA AL AGREGAR DESDE EL CROSS-SELLING.
      // SINTOMA (Sebastian): en /cart pulso "Agregar" en una tarjeta del cross-selling, veo
      // el vuelo, sube la barra de envio gratis y cambia el subtotal, pero el cajon sigue
      // mostrando lo viejo. CAUSA: se pedia e inyectaba la seccion 'minicart-form', que era
      // la del tema Glozin y en este tema NO EXISTE: ni la seccion ni el id. El cajon de
      // este tema es <cart-drawer> de Dawn, contenedor #CartDrawer. /cart/add.js devolvia
      // una seccion vacia, la inyeccion fallaba siempre y solo quedaba cajonSucio = true.
      // ARREGLO: pedir e inyectar la seccion 'cart-drawer', el mismo camino que usa
      // assets/product-form.js con el boton de la ficha, que es el que si funciona.
      // NO se inyecta 'cart-icon-bubble' a proposito: esa seccion de Dawn traeria su
      // propio marcado y pisaria la clase mc-header__contador de micase-header; el numero
      // del carrito se actualiza a mano mas abajo con el item_count que ya trae la
      // respuesta, que ademas es un dato exacto y no una recarga de HTML.
      function idsCajon(){
        return 'cart-drawer';
      }
      function contadorCajon(st){
        // El numero del carrito de la cabecera: marcado propio de MIcase, se actualiza con
        // el dato exacto de la respuesta en vez de reinyectar la seccion de Dawn.
        try{
          var n = st && typeof st.item_count === 'number' ? st.item_count : null;
          if(n === null) return;
          var els = document.querySelectorAll('.cart-count, .mc-header__contador, .cart-count-bubble span[aria-hidden="true"]');
          for(var i = 0; i < els.length; i++){
            var el = els[i], hecho = false;
            for(var j = 0; j < el.childNodes.length; j++){
              if(el.childNodes[j].nodeType === 3){ el.childNodes[j].nodeValue = n; hecho = true; break; }
            }
            if(!hecho) el.insertBefore(document.createTextNode(n), el.firstChild);
          }
        }catch(e){ console.warn('[MIcase] micase-popups: no se pudo actualizar el numero del carrito de la cabecera', e); }
      }
      function inyectaCajon(st){
        var ok = false;
        try{
          var html = st && st.sections && st.sections['cart-drawer'];
          var host = document.getElementById('CartDrawer');
          if(host && html){
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var src = doc.getElementById('CartDrawer');
            if(src){
              host.innerHTML = src.innerHTML;
              ok = true;
              var dr = document.querySelector('cart-drawer');
              if(dr){
                // El cajon vacio/lleno se distingue por clase: si no se actualiza, el
                // boton de pagar queda deshabilitado con productos dentro.
                var vacio = !!host.querySelector('.drawer__inner-empty');
                dr.classList.toggle('is-empty', vacio);
                // Al reemplazar el interior se pierde el listener del fondo; se reengancha
                // igual que hace renderContents() de Dawn.
                var capa = host.querySelector('#CartDrawer-Overlay');
                if(capa && typeof dr.close === 'function'){ try{ capa.addEventListener('click', dr.close.bind(dr)) }catch(e){ console.warn('[MIcase] micase-popups: no se pudo reenganchar el cierre por el fondo del cajon', e); } }
                if(!C.nocajon && typeof dr.open === 'function'){ try{ dr.open() }catch(e){ console.warn('[MIcase] micase-popups: fallo al abrir el cajon del carrito despues de inyectar el HTML', e); } }
              }
            }
          }
          contadorCajon(st);
        }catch(e){ console.warn('[MIcase] micase-popups: fallo al inyectar el HTML del cajon del carrito', e); }
        cajonSucio = !ok;
        return ok;
      }
      function refrescaCajon(){
        try{
          var sep = window.location.search ? (window.location.search + '&') : '?';
          fetch(window.location.pathname + sep + 'sections=' + encodeURIComponent(idsCajon()), {credentials:'same-origin'})
            .then(function(r){ if(!r.ok) throw 0; return r.json() })
            .then(function(st){ inyectaCajon({ sections: st }) })
            .catch(function(e){ console.warn('[MIcase] micase-popups: fallo al pedir las secciones para refrescar el cajon del carrito', e); });
        }catch(e){ console.warn('[MIcase] micase-popups: fallo al refrescar el cajon del carrito', e); }
      }

      // 2026-08-10 · EL CAJON SEGUIA ABRIENDOSE DESDE EL BOTON DE LA FICHA.
      // SINTOMA (Sebastian): desde el cross-selling ya no se abre, pero el boton normal de
      // la ficha de producto si lo abre y corta el scroll: "la idea es que sigan
      // scrolleando en la pagina de producto y sigan agregando cosas".
      // CAUSA: esta funcion buscaba <cart-notification>, que es el aviso flotante de Dawn.
      // Este tema NO lo tiene en el DOM -la cabecera activa es micase-top-bar +
      // micase-header, no el header de Dawn-, asi que el 'if(!cn) return' salia SIEMPRE:
      // era codigo muerto, y con el quedaban inertes C.nocajon, marcaAdd, cajonSucio y
      // refrescaCajon(). Quien abre el cajon al agregar desde la ficha es
      // assets/product-form.js de Dawn, que llama a cartDrawer.open() sobre <cart-drawer>.
      // ARREGLO: se parchea open() del elemento correcto, <cart-drawer> (por prototipo,
      // que cubre cualquier instancia; si el prototipo no esta accesible todavia, sobre la
      // instancia). Si acaba de haber un anadido -marcaAdd dentro de la ventana corta- la
      // apertura se cancela y no pasa nada mas: el contenido ya se actualizo por su cuenta.
      // El icono del carrito de la cabecera pone marcaAdd = 0 antes (listener de captura,
      // mas abajo), asi que abrir a mano SIEMPRE funciona. Si el cajon quedo sucio se
      // refresca justo antes de abrirse. Cerrar, foco y accesibilidad los sigue haciendo
      // Dawn: no se toca close() ni se altera lo que devuelve open().
      function parcheaCajon(){
        if(!C.nocajon && !C.ajax) return;
        var dr = document.querySelector('cart-drawer');
        if(!dr) return;
        var proto = Object.getPrototypeOf(dr);
        var destino = (proto && typeof proto.open === 'function') ? proto : dr;
        if(!destino || typeof destino.open !== 'function' || destino.mcSinCajon) return;
        var orig = destino.open;
        destino.open = function(){
          if(C.nocajon && marcaAdd && (Date.now() - marcaAdd) < ventanaAdd){
            marcaAdd = 0;
            // No se abre, pero el contenido no puede quedarse viejo: si la inyeccion
            // fallo, se relee ahora para que la proxima apertura ya venga al dia.
            if(cajonSucio) refrescaCajon();
            return;
          }
          if(cajonSucio) refrescaCajon();
          return orig.apply(this, arguments);
        };
        destino.mcSinCajon = true;
      }

      document.addEventListener('click', function(e){
        var t = e.target;
        if(!t || !t.closest) return;
        if(t.closest('#cart-icon-bubble, .minicart__action, .header__minicart')){ marcaAdd = 0; return; }
        var b = t.closest(SEL_ADD);
        if(!b || b.disabled) return;
        marcaAdd = Date.now();
        parcheaCajon();
        vuela(b);
      }, true);

      if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', parcheaCajon);
      else parcheaCajon();
      // cart-drawer.js de Dawn se carga con defer: si el elemento aun no esta "upgraded",
      // su prototipo todavia no tiene open(). Se reintenta en cuanto queda definido.
      if(window.customElements && typeof customElements.whenDefined === 'function'){
        try{ customElements.whenDefined('cart-drawer').then(parcheaCajon) }catch(e){ console.warn('[MIcase] micase-popups: no se pudo esperar a que se definiera cart-drawer', e); }
      }

      function limpiaAviso(f){
        var n = f.querySelector('.mcpg-err');
        if(n && n.parentNode) n.parentNode.removeChild(n);
      }
      function aviso(f, txt){
        limpiaAviso(f);
        var t = txt || T.error || '';
        if(!t) return;
        var n = document.createElement('p');
        n.className = 'mcpg-err';
        n.setAttribute('role', 'status');
        n.textContent = t;
        f.appendChild(n);
        setTimeout(function(){ if(n.parentNode) n.parentNode.removeChild(n) }, 8000);
      }

      document.addEventListener('submit', function(e){
        if(!C.ajax) return;
        var f = e.target;
        if(!f || typeof f.matches !== 'function') return;
        if(!f.matches('form.mccombo__f, form.mcx__f')) return;
        if(f.getAttribute('data-mc-enviando') === '1'){ e.preventDefault(); return; }
        if(typeof window.fetch !== 'function' || typeof window.FormData !== 'function') return;
        var datos;
        try { datos = new FormData(f) } catch(err) { return }
        try { datos.append('sections', idsCajon()); datos.append('sections_url', window.location.pathname); } catch(err) { console.warn('[MIcase] micase-popups: no se pudo adjuntar la lista de secciones al formulario del carrito', err); }

        e.preventDefault();
        limpiaAviso(f);
        f.setAttribute('data-mc-enviando', '1');
        var btn = f.querySelector('button');
        var textoOriginal = btn ? btn.textContent : '';
        if(btn){
          btn.disabled = true;
          if(T.espera) btn.textContent = T.espera;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: datos
        })
        .then(function(r){
          return r.text().then(function(t){
            var j = null;
            try { j = JSON.parse(t) } catch(x) { console.warn('[MIcase] micase-popups: no se pudo leer la respuesta JSON de /cart/add.js', x); }
            return { ok: r.ok, j: j };
          });
        })
        .then(function(res){
          if(!res.ok) throw (res.j || {});
          if(res.j) inyectaCajon(res.j);
          if(window.MCcarrito) window.MCcarrito.avisa();
        })
        .catch(function(err){
          aviso(f, (err && (err.description || err.message)) || '');
        })
        .then(function(){
          f.setAttribute('data-mc-enviando', '0');
          if(btn){
            btn.disabled = false;
            if(T.espera) btn.textContent = textoOriginal;
          }
        });
      }, true);

      window.MCcarrito = window.MCcarrito || (function(){
        var subs=[], t=null, listo=false;
        function reparte(c){ for(var i=0;i<subs.length;i++){ try{ subs[i](c) }catch(e){ console.warn('[MIcase] micase-popups: fallo un suscriptor de MCcarrito al recibir el carrito', e); } } }
        function lee(){
          fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
            .then(function(r){ if(!r.ok) throw 0; return r.json() })
            .then(reparte)
            .catch(function(){ reparte(null) });
        }
        function avisa(){ clearTimeout(t); t=setTimeout(lee,300); }
        function mira(n,cfg){ if(n){ try{ new MutationObserver(avisa).observe(n,cfg) }catch(e){ console.warn('[MIcase] micase-popups: no se pudo observar el nodo del carrito con MutationObserver', e); } } }
        function arranca(){
          if(listo) return; listo=true;
          try{
            if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate){
              subscribe(PUB_SUB_EVENTS.cartUpdate, avisa);
            }
          }catch(e){ console.warn('[MIcase] micase-popups: no se pudo suscribir al evento cartUpdate del tema', e); }
          if(typeof MutationObserver!=='function') return;
          var cc=document.querySelectorAll('[data-mc-contador], .cart-count');
          for(var i=0;i<cc.length;i++){ mira(cc[i].parentNode||cc[i],{childList:true,characterData:true,subtree:true}) }
          mira(document.getElementById('minicart-form'),{childList:true});
          window.addEventListener('pageshow',function(e){ if(e.persisted) avisa() });
        }
        if(document.readyState=='loading') document.addEventListener('DOMContentLoaded',arranca);
        else arranca();
        return { on:function(f){ if(typeof f=='function') subs.push(f) }, avisa:avisa };
      })();

      window.MCcarrito.on(function(c){
        if(!c || typeof c.item_count !== 'number') return;
        var nuevo = c.item_count > 100 ? '~' : String(c.item_count);
        var cc = document.querySelectorAll('[data-mc-contador], .cart-count');
        for(var i = 0; i < cc.length; i++){
          if(cc[i].classList.contains('cart-count-drawer')) continue;
          var n = cc[i].firstChild;
          if(n && n.nodeType === 3){
            if(n.nodeValue.trim() !== nuevo) n.nodeValue = nuevo;
          } else if((cc[i].textContent || '').trim() !== nuevo){
            cc[i].textContent = nuevo;
          }
        }
        var ht = document.querySelector('header-total-price');
        if(ht && typeof ht.updateTotal === 'function'){ try{ ht.updateTotal(c) }catch(e){ console.warn('[MIcase] micase-popups: fallo al actualizar el total en la cabecera', e); } }
      });

      // 2026-08-02 · AL VOLVER ATRAS, EL CAJON QUEDABA VACIO.
      // SINTOMA (Sebastian): agrego tres productos, pulso "Ir a pagar" y volvio con el
      // boton atras. La pagina mostraba los tres, pero al abrir el cajon del carrito no
      // aparecia nada. CAUSA: al volver, el navegador restaura la pagina desde su cache
      // con el HTML tal y como estaba -minicarrito incluido- y nadie marcaba ese HTML
      // como sucio, asi que el cajon se abria sin releerlo.
      // ARREGLO: se engancha el mecanismo cajonSucio que YA existia, en dos puertas.
      //   1) pageshow con persisted: la pagina viene de la bfcache, el HTML del cajon no
      //      es de fiar y se marca sucio sin preguntar. No cuesta una peticion: la
      //      relectura solo ocurre si la persona llega a ABRIR el cajon.
      //   2) visibilitychange al volver a ser visible: eso pasa muchas veces al dia al
      //      cambiar de pestana, asi que aqui NO se marca a ciegas. Se pide UNA sola
      //      lectura a window.MCcarrito -la misma que ya alimenta el contador, con su
      //      antirrebote de 300ms, asi que no se anade una peticion nueva- y solo si el
      //      carrito cambio de verdad se marca sucio. Si no cambio, cero trabajo.
      // Sin setInterval y sin bucles: dos listeners y una comparacion de cadenas.
      // NO abre el cajon por su cuenta: solo levanta la bandera. El guardia de marcaAdd
      // que impide que se abra solo al agregar queda intacto.
      var firmaCarro = null;
      function firmaDe(c){
        if(!c || typeof c.item_count !== 'number') return null;
        var s = String(c.item_count) + '|' + String(c.total_price);
        var it = c.items || [];
        for(var i = 0; i < it.length; i++){ s += '|' + it[i].key + ':' + it[i].quantity; }
        return s;
      }
      window.MCcarrito.on(function(c){
        var f = firmaDe(c);
        if(f === null) return;
        if(firmaCarro !== null && f !== firmaCarro) cajonSucio = true;
        firmaCarro = f;
      });
      window.addEventListener('pageshow', function(e){
        if(!e || !e.persisted) return;
        cajonSucio = true;
        firmaCarro = null;
        parcheaCajon();
      });
      document.addEventListener('visibilitychange', function(){
        if(document.visibilityState !== 'visible') return;
        parcheaCajon();
        if(window.MCcarrito) window.MCcarrito.avisa();
      });

      var caja = document.getElementById('mcpg');
      if(!C.pagar || !caja) return;

      var ruta = window.location.pathname || '';
      // Nunca en el carrito ni en el pago. Se cubre /checkout y /checkouts.
      if(/\/cart(\/|$)/.test(ruta) || ruta.indexOf('/checkout') > -1) return;

      var minItems = (typeof C.items === 'number' && C.items > 0) ? C.items : 2;
      var segEspera = (typeof C.segundos === 'number' && C.segundos > 0) ? C.segundos : 20;
      function horaCorte(){
        var n = document.getElementById('mcdesp');
        var v = n ? parseInt(n.getAttribute('data-corte'), 10) : NaN;
        if(!isNaN(v) && v >= 0 && v <= 23) return v;
        return (typeof C.corte === 'number' && C.corte >= 0 && C.corte <= 23) ? C.corte : 12;
      }
      var minPromo = (typeof C.minutos === 'number' && C.minutos > 0) ? C.minutos : 10;
      var umbralStock = (typeof C.stockUmbral === 'number' && C.stockUmbral > 0) ? C.stockUmbral : 5;

      var STOCK = {}, pedidos = {}, ETI = {};
      /* TOPE = precio del producto MAS CARO que sirve para el modelo del visitante, en
         centavos. Es lo que decide si el hueco hasta el envio gratis se puede cerrar con
         UN solo producto. null = todavia no se ha consultado; 0 = no se pudo. */
      var TOPE = null;
      function mapa(id){
        var n = document.getElementById(id);
        if(!n) return;
        try{
          var o = JSON.parse(n.textContent) || {};
          for(var k in o){ if(typeof o[k] === 'number' && o[k] > 0) STOCK[k] = o[k] }
        }catch(e){ console.warn('[MIcase] micase-popups: no se pudo leer el JSON del mapa de inventario', e); }
      }
      mapa('mcpg-stock');
      mapa('mcstock-data');

      function unidades(id){
        var q = STOCK[id];
        if(typeof q !== 'number') q = STOCK[String(id)];
        return (typeof q === 'number') ? q : null;
      }

      function pideStock(handle, cb){
        if(!handle || pedidos[handle]){ cb(); return }
        pedidos[handle] = 1;
        fetch('/products/' + handle + '.js', {credentials:'same-origin',headers:{'Accept':'application/json'}})
          .then(function(r){ if(!r.ok) throw 0; return r.json() })
          .then(function(pr){
            var vs = (pr && pr.variants) || [];
            for(var i=0;i<vs.length;i++){
              if(typeof vs[i].inventory_quantity === 'number' && vs[i].inventory_management && vs[i].inventory_quantity > 0){
                STOCK[vs[i].id] = vs[i].inventory_quantity;
              }
            }
            /* 2026-08-18: la misma respuesta trae las etiquetas, y son las que dicen QUE
               tipo de proteccion lleva ya en el carrito. No cuesta una peticion nueva. */
            try{ ETI[handle] = ',' + ((pr && pr.tags) || []).join(',').toLowerCase() + ','; }catch(e){}
          })
          .catch(function(e){ console.warn('[MIcase] micase-popups: fallo al pedir el inventario de las variantes del producto', e); })
          .then(cb);
      }

      function resuelveStock(c, cb){
        var hecho = false;
        function fin(){ if(hecho) return; hecho = true; cb() }
        if(!c || !c.items){ fin(); return }
        var falta = {}, n = 0;
        for(var i=0;i<c.items.length;i++){
          var it = c.items[i];
          /* 2026-08-18: antes solo se pedia si faltaba el STOCK. Ahora tambien si faltan las
             ETIQUETAS, porque de ellas depende que mensaje se pinta. Es la misma peticion. */
          var sinStock = C.stock && unidades(it.variant_id) === null;
          var sinEti = !ETI[it.handle];
          if((sinStock || sinEti) && it.handle && !pedidos[it.handle] && !falta[it.handle]){
            falta[it.handle] = 1; n++;
          }
        }
        if(!n){ fin(); return }
        setTimeout(fin, 2500);
        for(var h in falta){ pideStock(h, function(){ if(--n <= 0) fin() }) }
      }

      function escaso(c){
        if(!C.stock || !c || !c.items) return null;
        var mejor = null;
        for(var i=0;i<c.items.length;i++){
          var q = unidades(c.items[i].variant_id);
          if(q === null || q <= 0 || q > umbralStock) continue;
          if(!mejor || q < mejor.q) mejor = { q: q, m: c.items[i].variant_title || c.items[i].product_title || '' };
        }
        return mejor;
      }

      function esc(t){
        return String(t == null ? '' : t).replace(/[&<>"]/g, function(m){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[m]; });
      }
      var abierto = false, disparado = false, focoPrevio = null;
      var reloj = null, espera = null, minimo = null, onScroll = null, onSalida = null;
      var carrito = null, previo = null, finPromo = 0;
      var agregados = 0, ultimoAdd = 0;
      try {
        agregados = parseInt(sessionStorage.getItem('mcpg_add'), 10) || 0;
        ultimoAdd = parseInt(sessionStorage.getItem('mcpg_ts'), 10) || 0;
      } catch(e) { console.warn('[MIcase] micase-popups: no se pudo leer de sessionStorage cuantas veces se agrego al carrito', e); }
      var esperaMin = (typeof C.esperaMin === 'number' && C.esperaMin >= 0) ? C.esperaMin : 8;
      var scrollPct = (typeof C.scrollPct === 'number' && C.scrollPct > 0 && C.scrollPct <= 100) ? C.scrollPct : 65;

      // 2026-08-11 · SEGUNDO INTENTO DEL POP-UP DE PAGAR.
      // No se dispara por tiempo ni por scroll: se dispara porque el cliente RECHAZO el
      // primero con el boton secundario y aun asi siguio ANADIENDO al carrito. Quien
      // rechaza y sigue sumando esta mas cerca de comprar; volver por reloj seria acoso.
      // Cerrar con la X o con el fondo NO cuenta como rechazo: ese gesto es "quitate de
      // encima" y apaga el segundo intento para siempre en esa sesion.
      // Todo el estado vive en sessionStorage, no en localStorage: manana el cliente
      // vuelve a tener sus dos oportunidades.
      var P2 = {
        on: C.p2 !== false,
        espera: (typeof C.p2espera === 'number' && C.p2espera >= 0) ? C.p2espera : 45,
        t: C.t2 || {}
      };
      var intento = 0, vistas = 0, rechazo = 0, addTrasRechazo = false, reloj2 = null;
      try {
        vistas = parseInt(sessionStorage.getItem('mcpg_n'), 10) || 0;
        rechazo = parseInt(sessionStorage.getItem('mcpg_rech'), 10) || 0;
        addTrasRechazo = sessionStorage.getItem('mcpg_add2') === '1';
      } catch(e) { console.warn('[MIcase] micase-popups: no se pudo leer de sessionStorage el estado del segundo intento de pagar', e); }
      function guardaP2(){
        try{
          sessionStorage.setItem('mcpg_n', String(vistas));
          sessionStorage.setItem('mcpg_rech', String(rechazo));
          sessionStorage.setItem('mcpg_add2', addTrasRechazo ? '1' : '0');
        }catch(e){ console.warn('[MIcase] micase-popups: no se pudo guardar en sessionStorage el estado del segundo intento de pagar', e); }
      }
      function faltaP2(){
        if(!rechazo) return -1;
        var t = P2.espera * 1000 - (Date.now() - rechazo);
        return t > 0 ? t : 0;
      }
      function cancelaP2(){
        clearTimeout(reloj2); reloj2 = null;
        if(!rechazo && !addTrasRechazo) return;
        rechazo = 0; addTrasRechazo = false;
        guardaP2();
      }
      function armaP2(){
        if(!P2.on || abierto || vistas >= 2) return;
        if(!rechazo || !addTrasRechazo) return;
        var f = faltaP2();
        if(f < 0) return;
        clearTimeout(reloj2);
        reloj2 = setTimeout(function(){ pideTope(function(){ resuelveStock(carrito, function(){ abrir(2) }) }) }, f);
      }
      function marcaRechazo(){
        // Solo el primer intento genera derecho a un segundo.
        if(!P2.on || intento !== 1 || vistas >= 2) return;
        rechazo = Date.now();
        addTrasRechazo = false;
        guardaP2();
      }
      // 2026-08-11 · LA INTENCION DEL POP-UP LA MANDA EL CARRITO, NO EL INTENTO.
      // El carrito ideal de MIcase son 3 productos. Empujar al pago a quien lleva 1 lo
      // saca del catalogo justo donde sube el ticket. Por eso, al ABRIR (en cualquiera
      // de los dos intentos) se mira item_count: por debajo de la meta se pinta el juego
      // "sumar" -que manda al catalogo- y de la meta en adelante el juego de pagar, que
      // es el de siempre. El numero de intento sigue mandando en CUANDO aparece; el
      // tamano del carrito manda en QUE dice. El tope sigue siendo dos apariciones.
      var SUM = C.sumar || {};
      function metaCarrito(){
        var m = parseInt(C.meta, 10);
        return (m >= 2 && m <= 5) ? m : 3;
      }
      function llevaAhora(){
        return (carrito && typeof carrito.item_count === 'number') ? carrito.item_count : 0;
      }
      /* ==================================================================
         EL POP-UP ELIGE QUE DECIR SEGUN LO QUE PUEDE DEMOSTRAR. 2026-08-18.

         EL PROBLEMA QUE RESUELVE. Hasta hoy el mensaje se elegia contando articulos:
         por debajo de la meta invitaba a sumar y por encima a pagar. Eso obliga a
         escribir UNA copia que valga para todos los carritos, y no existe:
           - "Con dos mas queda protegido completo" es falso si ya lleva el protector.
           - "Ahorra mas si agregas mas" es falso siempre: MIcase no tiene descuento por
             volumen, el precio por unidad no cambia.
           - "Te faltan $X para el envio gratis" es cierto siempre, pero con el ticket
             promedio en 61.122 el hueco tipico es de unos 49.000: pedir 49 mil para
             ahorrar 12 mil no convence a nadie y ademas ensena que el envio cuesta poco.

         LA REGLA. Tres estados, y se elige el primero que se pueda PROBAR:

           1. ENVIO - el hueco hasta el envio gratis se cierra con UN SOLO producto de los
              que sirven para su modelo. No es un umbral escrito a mano: se compara el
              hueco contra el precio del producto mas caro disponible para ese modelo. Si
              cabe, el envio manda, porque es la unica cifra exacta y alcanzable.
           2. PROTECCION - no lleva protector de pantalla. Es la posicion de la marca y es
              cierto: la funda cuida los bordes, la pantalla y la camara siguen al aire.
           3. PAGAR - ya lleva todo, o el hueco es tan grande que pedir mas seria absurdo.
              No se pide nada: se cierra el pedido.

         POR QUE ESE ORDEN. El envio va primero porque trae una cifra concreta que el
         cliente puede verificar en su propio carrito. La proteccion es un argumento, no un
         numero, y un argumento nunca gana a un dato comprobable.

         DE DONDE SALE EL TOPE. De /collections/<coleccion>/<modelo>/products.json, la
         misma coleccion y el mismo modelo a los que apunta el boton. Una peticion, y solo
         para quien esta a punto de ver el pop-up: no se pide en cada carga de pagina. Si
         falla, TOPE queda en 0 y el estado ENVIO sencillamente no se activa, que es la
         degradacion correcta: mejor no prometer que prometer sin poder cumplir.
         ================================================================== */
      function faltaEnvio(){
        if(!C.umbral || !carrito) return 0;
        var f = C.umbral - (carrito.items_subtotal_price || 0);
        return f > 0 ? f : 0;
      }
      function llevaCat(cat){
        if(!carrito || !carrito.items) return false;
        for(var i=0;i<carrito.items.length;i++){
          var t = ETI[carrito.items[i].handle];
          if(t && t.indexOf(',' + cat + ',') > -1) return true;
        }
        return false;
      }
      function pideTope(cb){
        if(TOPE !== null){ cb(); return }
        var h = handleModelo();
        var base = (SUM.url && String(SUM.url)) || '/collections/proteccion-accesorios-para-celulares-xiaomi-redmi-poco';
        base = base.replace(/\/+$/, '');
        var url = base + (h ? '/' + h : '') + '/products.json?limit=250';
        var listo = false;
        function fin(){ if(listo) return; listo = true; cb() }
        setTimeout(function(){ if(TOPE === null) TOPE = 0; fin() }, 2500);
        fetch(url, {credentials:'same-origin', headers:{'Accept':'application/json'}})
          .then(function(r){ if(!r.ok) throw 0; return r.json() })
          .then(function(d){
            var max = 0, ps = (d && d.products) || [];
            for(var i=0;i<ps.length;i++){
              var vs = ps[i].variants || [];
              for(var j=0;j<vs.length;j++){
                if(vs[j].available === false) continue;
                var pr = Math.round(parseFloat(vs[j].price) * 100);
                if(!isNaN(pr) && pr > max) max = pr;
              }
            }
            TOPE = max;
          })
          .catch(function(e){ TOPE = 0; console.warn('[MIcase] micase-popups: no se pudo leer el catalogo del modelo para decidir el mensaje', e); })
          .then(fin);
      }
      function estado(){
        var f = faltaEnvio();
        if(f > 0 && TOPE && f <= TOPE) return 'envio';
        if(!llevaCat('cat:pantalla')) return 'proteccion';
        return 'pagar';
      }
      function tocaSumar(){ return estado() !== 'pagar'; }
      // {faltan} se resuelve como PALABRA para que el texto funcione igual con uno que
      // con varios: "Con uno mas llegas..." / "Con dos mas llegas...". Con la cifra
      // cruda la frase quedaba coja en el caso de 1, que es justo el mas frecuente.
      function palabraFaltan(n){
        var p = { 1: 'uno', 2: 'dos', 3: 'tres', 4: 'cuatro' };
        return p[n] || String(n);
      }
      // Misma fuente que el buscador (assets/micase-buscador.js): el modelo del
      // visitante vive en localStorage 'micase_modelo' -lo escribe micase-detecta- y el
      // historial en 'micase_modelos_recientes'. Y el mismo destino que arma el
      // buscador: /collections/<coleccion>/<handle-del-modelo>.
      function handleModelo(){
        var r = null;
        try{
          r = JSON.parse(window.localStorage.getItem('micase_modelo') || 'null');
          if(!r || !(r.h || r.handle)){
            var prev = JSON.parse(window.localStorage.getItem('micase_modelos_recientes') || 'null');
            r = (prev && prev.length) ? prev[0] : null;
          }
        }catch(e){ console.warn('[MIcase] micase-popups: no se pudo leer el modelo guardado del visitante', e); r = null; }
        var h = r && (r.h || r.handle);
        return h ? String(h) : '';
      }
      function urlSumar(){
        var base = (SUM.url && String(SUM.url)) || '/collections/fundas-para-xiaomi-redmi-poco';
        var h = handleModelo();
        // Solo se filtra por modelo si la URL es una coleccion limpia. Con parametros,
        // anclas o rutas mas largas se deja tal cual: mejor sin filtrar que rota.
        if(h && /^(?:https?:\/\/[^\/]+)?\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[a-z0-9_-]+\/?$/i.test(base)){
          return base.replace(/\/+$/, '') + '/' + h;
        }
        return base;
      }
      // Textos y destino que trae el marcado de Liquid: son los del juego de pagar. Se
      // guardan una sola vez para poder VOLVER a ellos, porque ahora el mismo elemento
      // alterna entre dos juegos dentro de la misma sesion.
      var ORIG = null;
      function guardaOriginales(){
        if(ORIG) return;
        var h = caja.querySelector('#mcpg-h');
        var s = caja.querySelector('.mcpg-sub');
        var a = caja.querySelector('.mc-pop-cta');
        var b2 = caja.querySelector('.mcpg-b2');
        ORIG = {
          h: h ? h.textContent : '',
          s: s ? s.textContent : '',
          cta: a ? a.textContent : '',
          href: (a && a.getAttribute('href')) || '/checkout',
          cta2: b2 ? b2.textContent : ''
        };
      }
      // Mismo elemento, mismo marcado: solo se reescribe el TEXTO y el destino del boton.
      function textos(n){
        guardaOriginales();
        var h = caja.querySelector('#mcpg-h');
        var s = caja.querySelector('.mcpg-sub');
        var a = caja.querySelector('.mc-pop-cta');
        var b2 = caja.querySelector('.mcpg-b2');
        // El subtitulo no existe en el marcado si el ajuste venia vacio. Se crea una
        // sola vez y se reutiliza en los dos juegos.
        if(!s && h && h.parentNode){
          s = document.createElement('p');
          s.className = 'mcpg-sub';
          s.hidden = true;
          h.parentNode.insertBefore(s, h.nextSibling);
        }
        var est = estado();
        if(est !== 'pagar'){
          /* Los dos juegos de sumar comparten marcado y destino: solo cambian los textos.
             ENV es el del envio -que trae la cifra exacta- y SUM el de la proteccion. */
          /* TEXTOS DEL ESTADO ENVIO. Van con respaldo escrito aqui a proposito: el estado
             nuevo tiene que funcionar el dia que se sube, aunque el ajuste todavia no exista
             en el editor. En cuanto #mcpg-cfg traiga "envio", manda el editor y esto no se
             vuelve a leer. {falta} es la cifra exacta que le queda, ya en pesos. */
          var ENV_DEF = {
            h: 'Te faltan {falta} y el envio va por nuestra cuenta',
            b: 'Llevas {n}. Con un producto mas para tu modelo llegas al envio gratis y no pagas el domicilio.',
            cta: 'Ver que me falta',
            cta2: 'Ahora no, sigo mirando'
          };
          var J = (est === 'envio') ? (C.envio || ENV_DEF) : SUM;
          if (est === 'envio' && C.envio) {
            J = {
              h: C.envio.h || ENV_DEF.h,
              b: C.envio.b || ENV_DEF.b,
              cta: C.envio.cta || ENV_DEF.cta,
              cta2: C.envio.cta2 || ENV_DEF.cta2
            };
          }
          var faltan = metaCarrito() - llevaAhora();
          if(faltan < 1) faltan = 1;
          function pon(t){
            return String(t == null ? '' : t)
              .replace('{n}', String(llevaAhora()))
              .replace('{faltan}', palabraFaltan(faltan))
              .replace('{falta}', pesos(faltaEnvio()));
          }
          if(h && J.h) h.textContent = pon(J.h);
          if(s){
            var cuerpo = J.b ? pon(J.b) : '';
            s.textContent = cuerpo;
            s.hidden = !cuerpo;
          }
          if(a){
            if(J.cta) a.textContent = J.cta;
            a.setAttribute('href', urlSumar());
          }
          if(b2 && J.cta2) b2.textContent = J.cta2;
          return;
        }
        // Juego de pagar. Se restaura lo original por si el intento anterior dejo
        // puesto el juego de sumar, y solo despues manda el texto del segundo intento.
        if(h) h.textContent = ORIG.h;
        if(s){ s.textContent = ORIG.s; s.hidden = !ORIG.s; }
        if(a){ a.textContent = ORIG.cta; a.setAttribute('href', ORIG.href); }
        if(b2) b2.textContent = ORIG.cta2;
        if(n !== 2) return;
        if(h && P2.t.h) h.textContent = P2.t.h;
        if(s && P2.t.b){
          s.textContent = String(P2.t.b).replace('{n}', String(llevaAhora()));
          s.hidden = false;
        }
        if(a && P2.t.cta) a.textContent = P2.t.cta;
        if(b2 && P2.t.cta2) b2.textContent = P2.t.cta2;
      }

      function memoria(){ return C.frec === 'sesion' ? window.sessionStorage : window.localStorage }
      function yaVisto(){
        try{
          if(C.frec === 'siempre') return false;
          var v = memoria().getItem(C.clave);
          if(!v) return false;
          if(C.frec === 'dia') return (Date.now() - parseInt(v, 10)) < 86400000;
          return true;
        }catch(e){ return false }
      }
      function marcar(){ try{ memoria().setItem(C.clave, String(Date.now())) }catch(e){ console.warn('[MIcase] micase-popups: no se pudo marcar el popup como visto en el almacenamiento', e); } }

      function miles(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
      function pesos(c){ return '$' + miles(Math.round((c || 0) / 100)) }

      function bogota(){
        var d = new Date();
        return new Date(d.getTime() + d.getTimezoneOffset() * 60000 - 5 * 3600000);
      }
      function hms(s){
        if(s < 0) s = 0;
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), q = s % 60;
        if(h >= 24) return Math.floor(h / 24) + ' d ' + (h % 24) + ' h';
        if(h > 0) return h + ' h ' + m + ' min';
        if(m > 0) return m + ' min ' + (q < 10 ? '0' : '') + q + ' s';
        return q + ' s';
      }
      function textoReloj(){
        if(C.modo === 'ninguno') return '';
        if(C.modo === 'minutos'){
          var s = Math.floor((finPromo - Date.now()) / 1000);
          if(s <= 0) return '';
          return (T.promo || '').replace('{tiempo}', '<b>' + hms(s) + '</b>');
        }
        var b = bogota(), dia = b.getDay(), hora = b.getHours();
        var habil = dia >= 1 && dia <= 5;
        var hc = horaCorte();
        var p = new Date(b.getTime());
        p.setHours(hc, 0, 0, 0);
        if(p <= b) p.setDate(p.getDate() + 1);
        while(p.getDay() === 0 || p.getDay() === 6) p.setDate(p.getDate() + 1);
        var s2 = Math.floor((p - b) / 1000);
        if(habil && hora < hc) return (T.corte || '').replace('{tiempo}', '<b>' + hms(s2) + '</b>');
        var proximo = (dia === 5 || dia === 6) ? T.lunes : T.manana;
        return (T.cerrado || '')
          .replace('{dia}', '<b>' + proximo + '</b>')
          .replace('{tiempo}', '<b>' + hms(s2) + '</b>');
      }
      function pintaReloj(){
        var p = caja.querySelector('.mcpg-reloj'), t = caja.querySelector('.mcpg-reloj__t');
        if(!p || !t) return;
        var txt = textoReloj();
        if(!txt){ p.hidden = true; return }
        t.innerHTML = txt;
        p.hidden = false;
      }

      function pinta(c){
        var mini = caja.querySelector('.mcpg-mini');
        var items = (c && c.items) || [];
        if(mini){
          // 2026-08-10 · EL POPUP REPETIA LA MISMA MINIATURA.
          // SINTOMA (Sebastian): con tres lineas del mismo producto salian tres fotos
          // identicas y se veia raro. CAUSA: se recorria c.items, que son LINEAS del
          // carrito, sin deduplicar; varias variantes del mismo producto comparten foto.
          // ARREGLO: una miniatura por PRODUCTO (decision de Sebastian, 2026-08-10). Se
          // salta la linea si ya se pinto ese product_id o esa misma imagen (la URL se
          // compara sin los parametros de tamano, que cambian sin cambiar la foto). El
          // "+N" cuenta productos distintos que no cupieron, no lineas sobrantes.
          mini.textContent = '';
          var vistos = {}, distintos = 0, puestas = 0;
          for(var i = 0; i < items.length; i++){
            var src = items[i].image || (items[i].featured_image && items[i].featured_image.url);
            if(!src) continue;
            var kp = items[i].product_id ? ('#p' + items[i].product_id) : '';
            var ki = '#i' + String(src).split('?')[0];
            if((kp && vistos[kp] === 1) || vistos[ki] === 1) continue;
            if(kp) vistos[kp] = 1;
            vistos[ki] = 1;
            distintos++;
            if(puestas >= 4) continue;
            var im = document.createElement('img');
            im.src = src; im.alt = ''; im.setAttribute('aria-hidden', 'true');
            im.width = 52; im.height = 52; im.loading = 'lazy';
            mini.appendChild(im);
            puestas++;
          }
          if(distintos > puestas && puestas > 0){
            var mas = document.createElement('span');
            mas.className = 'mcpg-mas';
            mas.textContent = '+' + (distintos - puestas);
            mini.appendChild(mas);
          }
          mini.hidden = puestas === 0;
        }

        var res = caja.querySelector('.mcpg-res');
        if(res){
          if(T.resumen && c && c.item_count){
            var pal = c.item_count === 1 ? (T.pal1 || '') : (T.paln || '');
            res.innerHTML = T.resumen
              .replace('{n}', '<b>' + c.item_count + ' ' + pal + '</b>')
              .replace('{total}', '<b>' + pesos(c.items_subtotal_price) + '</b>');
            res.hidden = false;
          } else { res.hidden = true }
        }

        var li = caja.querySelectorAll('.mcpg-l li');
        for(var k = 0; k < li.length; k++){
          var clave = li[k].getAttribute('data-k'), txt = '';
          if(clave === 'stock'){
            var e = escaso(c);
            if(e){
              txt = (e.q === 1 ? (T.stock1 || '') : (T.stockn || ''))
                .replace('{n}', '<b>' + e.q + '</b>')
                .replace('{modelo}', '<b>' + esc(e.m) + '</b>');
            }
          } else if(clave === 'envio' && C.umbral > 0 && c){
            var falta = C.umbral - (c.items_subtotal_price || 0);
            if(falta > 0) txt = (T.falta || '').replace('{falta}', '<b>' + pesos(falta) + '</b>');
            else txt = T.logrado || '';
          } else if(clave === 'social' && C.resenas > 0 && C.promedio && T.social){
            txt = T.social
              .replace('{n}', miles(C.resenas))
              .replace('{prom}', String(C.promedio || '').replace('.', ','));
          } else if(clave === 'pagos'){
            txt = T.pagos || '';
          }
          li[k].innerHTML = txt;
          li[k].hidden = !txt;
        }
      }

      function enfocables(){
        return caja.querySelectorAll('a[href], button:not([disabled])');
      }
      function teclado(e){
        if(e.key === 'Escape'){ cerrar(); return }
        if(e.key !== 'Tab') return;
        var f = enfocables();
        if(!f.length) return;
        var pri = f[0], ult = f[f.length - 1];
        if(e.shiftKey && document.activeElement === pri){ e.preventDefault(); ult.focus() }
        else if(!e.shiftKey && document.activeElement === ult){ e.preventDefault(); pri.focus() }
      }

      function abrir(n){
        n = (n === 2) ? 2 : 1;
        if(abierto) return;
        if(n === 1){
          if(disparado || yaVisto()) return;
          if(!carrito || !carrito.item_count) return;
          if(falta() !== 0) return;
        } else {
          // El segundo intento no mira yaVisto() ni disparado -esos son del primero-,
          // pero exige rechazo explicito, un anadido posterior y el suelo de espera.
          if(!P2.on || vistas >= 2) return;
          if(!rechazo || !addTrasRechazo) return;
          if(!carrito || !carrito.item_count) return;
          if(faltaP2() !== 0) return;
        }
        focoPrevio = document.activeElement;
        finPromo = Date.now() + minPromo * 60000;
        // REGLA DEL PROYECTO: la marca de "ya se mostro" se escribe al MOSTRAR, nunca
        // antes. Si pintar falla, no se marca nada y no se queman las banderas: el
        // pop-up podra volver a intentarlo en la misma pagina en vez de quedar mudo.
        try{
          textos(n);
          pinta(carrito);
          pintaReloj();
          caja.hidden = false;
          void caja.offsetWidth;
          caja.classList.add('mc-pop-on');
        }catch(e){
          console.warn('[MIcase] micase-popups: fallo al pintar el popup de pagar; no se marca como visto', e);
          try{ caja.hidden = true; caja.classList.remove('mc-pop-on'); }catch(e2){ console.warn('[MIcase] micase-popups: no se pudo volver a esconder el popup de pagar', e2); }
          return;
        }
        if(caja.hidden){ console.warn('[MIcase] micase-popups: el popup de pagar no quedo visible; no se marca como visto'); return; }
        quitaScroll();
        quitaSalida();
        clearTimeout(espera);
        clearTimeout(minimo);
        clearTimeout(reloj2); reloj2 = null;
        disparado = true;
        abierto = true;
        intento = n;
        vistas = vistas + 1;
        if(n === 1) marcar();
        else { rechazo = 0; addTrasRechazo = false; }
        guardaP2();
        document.addEventListener('keydown', teclado, true);
        var cta = caja.querySelector('.mc-pop-cta');
        if(cta) cta.focus({ preventScroll: true });
        reloj = setInterval(pintaReloj, 1000);
      }

      function cerrar(){
        if(!abierto) return;
        abierto = false;
        caja.classList.remove('mc-pop-on');
        document.removeEventListener('keydown', teclado, true);
        clearInterval(reloj); reloj = null;
        clearTimeout(minimo);
        setTimeout(function(){ caja.hidden = true }, 300);
        /* 2026-08-22 · CERRAR EL POP-UP NO PUEDE MOVER LA FICHA.
           Sebastian: "cuando le di quitar al pop up que me invitaba a pagar, me llevo al inicio
           de la product page... lo ideal es dejarla seguir navegando".
           Es el MISMO fallo del 18 de agosto en el cajon del carrito, por otra puerta. Alli la
           causa era removeTrapFocus() de assets/global.js llamando focus() a secas, y se cerro
           envolviendo esa funcion global desde assets/micase-cajon-foco.js. Este pop-up NO pasa
           por ahi: se guarda el foco al abrir y lo devuelve el mismo. Si ese elemento estaba
           arriba -el icono del carrito de la cabecera, que es de donde suele venir el cliente-
           el navegador lo trae a la vista y la ficha salta al principio. Medido: 2.000 px de
           salto en banco/popup-pagar-salto-test.mjs.
           EL FOCO SE SIGUE DEVOLVIENDO: eso es accesibilidad y no se toca. Lo unico que se anula
           es el desplazamiento que lo acompana. preventScroll lo resuelve donde existe; el
           scrollTo de atras es el cinturon para los navegadores que ignoran la opcion (Safari
           viejo la acepta sin aplicarla, no lanza). Solo se llama si de verdad se movio. */
        if(focoPrevio && focoPrevio.focus){
          var yAntes = window.scrollY || window.pageYOffset || 0;
          try{ focoPrevio.focus({ preventScroll: true }) }catch(e){ console.warn('[MIcase] micase-popups: no se pudo devolver el foco al elemento previo al cerrar el popup', e); }
          var yAhora = window.scrollY || window.pageYOffset || 0;
          if(yAhora !== yAntes){ try{ window.scrollTo(0, yAntes) }catch(e){ console.warn('[MIcase] micase-popups: no se pudo devolver la pagina a su sitio al cerrar el popup', e); } }
        }
      }

      function falta(){
        if(agregados < 1 || !ultimoAdd) return -1;
        var t = esperaMin * 1000 - (Date.now() - ultimoAdd);
        return t > 0 ? t : 0;
      }
      function intenta(){
        if(abierto || disparado || yaVisto()) return;
        if(!carrito || !carrito.item_count) return;
        var f = falta();
        if(f < 0) return;
        clearTimeout(minimo);
        if(f > 0){ minimo = setTimeout(function(){ pideTope(function(){ resuelveStock(carrito, abrir) }) }, f); return }
        pideTope(function(){ resuelveStock(carrito, abrir) });
      }

      var pendiente = false;
      function calculaScroll(){
        pendiente = false;
        var alto = document.documentElement.scrollHeight - window.innerHeight;
        if(alto <= 0) return;
        if((window.scrollY / alto) * 100 >= scrollPct){ quitaScroll(); intenta(); }
      }
      function quitaScroll(){
        if(!onScroll) return;
        window.removeEventListener('scroll', onScroll);
        onScroll = null;
      }
      function armaScroll(){
        if(!C.scrollOn || onScroll) return;
        onScroll = function(){
          if(pendiente) return;
          pendiente = true;
          requestAnimationFrame(calculaScroll);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      function quitaSalida(){
        if(!onSalida) return;
        document.removeEventListener('mouseout', onSalida);
        onSalida = null;
      }
      function armaSalida(){
        if(!C.salidaOn || onSalida) return;
        var fino = false;
        try { fino = !!(window.matchMedia && window.matchMedia('(pointer:fine)').matches) } catch(e) { console.warn('[MIcase] micase-popups: no se pudo consultar si el puntero es fino (pointer:fine)', e); }
        if(!fino) return;
        onSalida = function(ev){
          if(!ev.relatedTarget && ev.clientY < 10){ quitaSalida(); intenta(); }
        };
        document.addEventListener('mouseout', onSalida);
      }

      function armaSenales(){ armaScroll(); armaSalida(); }
      if(agregados >= 1) armaSenales();

      var cierres = caja.querySelectorAll('[data-mc-cerrar]');
      for(var z = 0; z < cierres.length; z++){
        (function(nodo){
          nodo.addEventListener('click', function(){
            // Solo el boton secundario (.mcpg-b2) cuenta como rechazo explicito y abre
            // la puerta al segundo intento. La X, el fondo y Escape la cierran.
            if(nodo.classList && nodo.classList.contains('mcpg-b2')) marcaRechazo();
            cerrar();
          });
        })(cierres[z]);
      }
      caja.addEventListener('click', function(e){ if(e.target === caja) cerrar() });

      function guarda(){
        try{
          sessionStorage.setItem('mcpg_add', String(agregados));
          sessionStorage.setItem('mcpg_ts', String(ultimoAdd));
        }catch(e){ console.warn('[MIcase] micase-popups: no se pudo guardar en sessionStorage el conteo de agregados al carrito', e); }
      }
      function armaReloj(){
        if(C.segOn === false) return;
        clearTimeout(espera);
        espera = setTimeout(intenta, segEspera * 1000);
      }

      // 2026-08-10 · EL POP-UP DE PAGAR NO APARECIA.
      // SINTOMA (Sebastian): agrego dos productos, sigo navegando y no sale nunca.
      // CAUSA: el unico reloj que llevaba al pop-up se armaba DENTRO de la rama
      // "c.item_count > previo", es decir solo en la pagina donde se hizo el anadido, y
      // como setTimeout, moria al cambiar de pagina. Al cargar la siguiente pagina
      // armaSenales() solo enganchaba scroll y salida (y la salida ni existe en movil,
      // pide pointer:fine), asi que quien anadia y seguia navegando solo lo veia si
      // bajaba hasta el 70% de una pagina. Ademas falta() devuelve -1 -bloqueo total- si
      // mcpg_add/mcpg_ts estan vacios, asi que un carrito que ya venia lleno de antes
      // nunca contaba como "tiene productos".
      // ARREGLO: en la PRIMERA lectura del carrito de cada pagina, si ya hay productos se
      // siembran los contadores (si hacen falta), se rearman las senales y se rearma el
      // reloj. Sigue mandando el suelo de espera de falta().
      window.MCcarrito.on(function(c){
        if(!c) return;
        carrito = c;
        // Carrito vacio: se cae el segundo intento, no hay pedido que cerrar.
        if(!c.item_count) cancelaP2();
        if(previo === null){
          previo = c.item_count;
          if(c.item_count > 0){
            // Si el anadido posterior al rechazo ocurrio en otra pagina, el segundo
            // intento se rearma aqui en vez de morir con el setTimeout de aquella.
            armaP2();
            if(agregados < 1 || !ultimoAdd){
              if(C.carritoPrevio === false) return;
              agregados = c.item_count;
              ultimoAdd = Date.now();
              guarda();
            }
            armaSenales();
            armaReloj();
          }
          return;
        }
        if(c.item_count > previo){
          agregados += (c.item_count - previo);
          ultimoAdd = Date.now();
          guarda();
          previo = c.item_count;
          // ESTA es la senal del segundo intento: anadio algo DESPUES de rechazar.
          if(P2.on && rechazo && vistas < 2){
            addTrasRechazo = true;
            guardaP2();
            armaP2();
            return;
          }
          armaSenales();
          if(C.itemsOn !== false && agregados >= minItems){ intenta(); return }
          armaReloj();
        } else {
          previo = c.item_count;
          // Vaciar el carrito devuelve el pop-up a cero: sin productos no se muestra.
          if(!c.item_count){ clearTimeout(espera); clearTimeout(minimo); }
        }
      });
      window.MCcarrito.avisa();
    })();

/* 2026-08-22 · ESTE ARCHIVO NO PUEDE TENER SANGRIA COMUN EN TODAS SUS LINEAS.
La cadena de bloque de GraphQL le quita a un archivo la indentacion MINIMA de todas sus
lineas -no solo los saltos finales de la regla 119-, y el md5 deja de cuadrar aunque no se
pierda una coma. La cabecera de arriba va sangrada a 3, asi que sin una linea en la COLUMNA 0
el archivo llegaria al tema con 3 espacios menos por linea. Esta es esa linea, y por eso
empieza pegada al margen. Regla 173.
Y OJO: en un archivo que se sube asi no puede aparecer la secuencia de tres comillas dobles.
Escaparla no sirve: el lexer de Shopify guarda las barras invertidas tal cual y sobran bytes.
Costo dos subidas averiguarlo. */